import React, { useContext, useEffect, useState } from "react";
import { LoanCalculatorWrapper } from "./style";
import img from "../../images/loan_calculation.png";
import RangeSlider from "../RangeSlider/RangeSlider";
import principalIcon from "../../images/Principal.svg";
import emiIcon from "../../images/EMI.svg";
import paybleIcon from "../../images/Total payble.svg";
import { getStorage, setStorage } from "../../Utils/common";
import Button from "../ui/Button";
import ContextDashboard from "../../Context/ContextDashboard";
import { calculateLoan, generateLoan } from "../../Utils/api";
import { useNavigate } from "react-router-dom";
import Select from "../../components/ui/Select";
import ProgressBar from "../../components/ProgressBar/ProgressBar";

const initialData = {
  loanPurpose: "",
};

const options = [
  { label: "Travel", value: "1" },
  { label: "Medical", value: "2" },
  { label: "Shopping", value: "3" },
  { label: "Others", value: "4" },
];

function LoanCalculator() {
  const [principal, setPrincipal] = useState(5000);
  const [tenure, setTenure] = useState(7);
  const [emi, setEmi] = useState(0);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingReject, setLoadingReject] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [formDataError, setFormDataError] = useState(initialData);
  const [progressBar, setProgressBar] = useState(getStorage("percent"));
  const [loanData, setLoanData] = useState([]);

  const { setMessage, logout, handleEvent } = useContext(ContextDashboard);

  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
      event_name: "generate_loan_quote",
    };
    generateLoan(params).then((resp) => {
      if (resp?.data?.Status === 1) {
        setStorage("percent", resp?.data?.Data?.step_percentage);
        setProgressBar(resp?.data?.Data?.step_percentage);
        setLoanData(resp?.data?.Data);
      }
    });
  }, []);

  const submit = (acceptedId) => {
    const param = {
      profile_id: getStorage("cust_profile_id") || "",
      event_name: "loan_quotation_decision",
      tenure: tenure,
      purpose_id: formData.loanPurpose,
      amount: principal,
      accepted_id: acceptedId,
    };

    if (acceptedId === "1") {
      setLoadingAccept(true);
      setLoadingReject(false);
    } else if (acceptedId === "2") {
      setLoadingReject(true);
      setLoadingAccept(false);
    }

    calculateLoan(param).then((resp) => {
      if (acceptedId === "1") setLoadingAccept(false);
      if (acceptedId === "2") setLoadingReject(false);

      if (resp?.data?.Status === 1) {
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("percent", resp?.data?.Data?.step_percentage);
        setProgressBar(resp?.data?.Data?.step_percentage);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "global",
        });
        handleEvent(getStorage("next_step"));
      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setMessage({ type: "error", msg: resp?.data?.Message });
      }
    });
  };

  const onChange = (e) => {
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormDataError({ ...formDataError, [name]: "" });
  };

  useEffect(() => {
    let si = (principal * tenure) / 100;
    setEmi(si);
  }, [principal, tenure]);

  return (
    <LoanCalculatorWrapper>
      <div className="container">
        {/* Header Section */}
        <div className="header">
          <h1>Loan <span>Calculator</span></h1>
          <p>Calculate your loan amount and tenure based on your eligibility</p>
        </div>

        {/* <div className="content-grid">
          {/* Left Side - Info Card */}
        {/* <div className="info-section">
          <div className="info-card">
            <div className="info-badge">Eligibility</div>
            <h3>Your Loan Eligibility</h3>
            <p className="info-description">
              We have calculated your loan eligibility based on the given details.
              Please choose the loan amount and tenure as per your requirements.
            </p>

            <div className="info-stats">
              <div className="stat-item">
                <span className="stat-label">Minimum Amount</span>
                <span className="stat-value">₹{loanData?.min_loan_amount?.toLocaleString() || '5,000'}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Maximum Amount</span>
                <span className="stat-value">₹{loanData?.max_loan_amount?.toLocaleString() || '1,00,000'}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Minimum Tenure</span>
                <span className="stat-value">{loanData?.min_loan_tenure || 7} days</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Maximum Tenure</span>
                <span className="stat-value">{loanData?.max_loan_tenure || 30} days</span>
              </div>
            </div>

            <div className="info-footer">
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>Instant Approval</span>
              </div>
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>No Hidden Charges</span>
              </div>
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>Flexible Tenure</span>
              </div>
            </div>
          </div>
        </div> */}

        {/* Right Side - Calculator */}
        {/* <div className="calculator-section">
          <div className="calculator-card">
            <div className="card-header">
              <h2>Customize Your Loan</h2>
              <p>Adjust the sliders to see your loan details</p>
            </div>

            {/* Purpose of Loan */}
        {/* <div className="input-group">
              <label>
                Purpose of Loan <span className="required">*</span>
              </label>
              <Select
                className="loan-purpose-select"
                name="loanPurpose"
                placeholder="Select purpose"
                error={formDataError?.loanPurpose}
                onChange={onChange}
                value={formData.loanPurpose}
                options={options}
              />
            </div> */}

        {/* Principal Amount */}
        {/* <div className="input-group">
              <div className="label-row">
                <label>Principal Amount <span className="required">*</span></label>
                <div className="value-chip">
                  <span className="currency">₹</span>
                  <span className="amount">{principal.toLocaleString()}</span>
                </div>
              </div>
              <RangeSlider
                min={loanData?.min_loan_amount || 5000}
                step="500"
                max={loanData?.max_loan_amount || 100000}
                value={principal}
                setValue={setPrincipal}
              />
              <div className="range-labels">
                <span>₹{(loanData?.min_loan_amount || 5000).toLocaleString()}</span>
                <span>₹{(loanData?.max_loan_amount || 100000).toLocaleString()}</span>
              </div>
            </div> */}

        {/* Tenure */}
        {/* <div className="input-group">
              <div className="label-row">
                <label>Loan Tenure <span className="required">*</span></label>
                <div className="value-chip">
                  <span className="amount">{tenure}</span>
                  <span className="unit">days</span>
                </div>
              </div>
              <RangeSlider
                min={loanData?.min_loan_tenure || 1}
                step="1"
                max={loanData?.max_loan_tenure || 90}
                value={tenure}
                setValue={setTenure}
              />
              <div className="range-labels">
                <span>{loanData?.min_loan_tenure || 1} days</span>
                <span>{loanData?.max_loan_tenure || 90} days</span>
              </div>
            </div> */}

        {/* Summary Cards */}
        {/* <div className="summary-cards">
              <div className="summary-card principal-card">
                <div className="card-icon">
                  <img src={principalIcon} alt="principal" />
                </div>
                <div className="card-details">
                  <span className="card-label">Principal Amount</span>
                  <span className="card-value">₹{principal.toLocaleString()}</span>
                </div>
              </div>

              <div className="summary-card total-card">
                <div className="card-icon">
                  <img src={paybleIcon} alt="total payable" />
                </div>
                <div className="card-details">
                  <span className="card-label">Total Payable</span>
                  <span className="card-value">₹{(Number(principal) + Number(emi)).toLocaleString()}</span>
                </div>
              </div>
            </div> */}

        {/* Interest Summary */}
        {/* <div className="interest-summary">
              <div className="interest-item">
                <span>Interest Amount</span>
                <span className="interest-value">₹{Math.round(emi).toLocaleString()}</span>
              </div>
            </div> */}

        {/* Action Buttons */}
        {/* <div className="action-buttons">
              <Button
                title="Accept & Continue"
                onClick={() => submit("1")}
                loading={loadingAccept}
                className="accept-button"
              />
            </div> */}

        {/* <p className="terms-note">
              By accepting, you agree to our <a href="/terms">Terms & Conditions</a>
            </p>
          </div>
        </div>  */}
        {/* </div>  */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 lg:gap-8">
          <div className="w-full">
            <div className="bg-gradient-to-br from-[#2D5F7A] to-[#1D3557] rounded-3xl p-5 sm:p-6 lg:p-8 shadow-xl text-white h-full">

              <div className="inline-flex items-center rounded-full bg-white/20 px-4 py-2 text-sm font-semibold">
                Eligibility
              </div>

              <h3 className="mt-6 text-2xl sm:text-3xl font-bold">
                Your Loan Eligibility
              </h3>

              <p className="mt-4 text-sm sm:text-base text-blue-100 leading-7">
                We have calculated your loan eligibility based on the given details.
                Please choose the loan amount and tenure as per your requirements.
              </p>

              <div className="mt-8 grid grid-cols-2 gap-3 sm:gap-4">

                <div className="rounded-2xl bg-white/10 p-4">
                  <p className="text-xs text-blue-200 uppercase">
                    Minimum Amount
                  </p>
                  <h4 className="mt-2 text-lg sm:text-xl font-bold">
                    ₹{loanData?.min_loan_amount?.toLocaleString() || "5,000"}
                  </h4>
                </div>

                <div className="rounded-2xl bg-white/10 p-4">
                  <p className="text-xs text-blue-200 uppercase">
                    Maximum Amount
                  </p>
                  <h4 className="mt-2 text-lg sm:text-xl font-bold">
                    ₹{loanData?.max_loan_amount?.toLocaleString() || "1,00,000"}
                  </h4>
                </div>

                <div className="rounded-2xl bg-white/10 p-4">
                  <p className="text-xs text-blue-200 uppercase">
                    Minimum Tenure
                  </p>
                  <h4 className="mt-2 text-lg sm:text-xl font-bold">
                    {loanData?.min_loan_tenure || 7} Days
                  </h4>
                </div>

                <div className="rounded-2xl bg-white/10 p-4">
                  <p className="text-xs text-blue-200 uppercase">
                    Maximum Tenure
                  </p>
                  <h4 className="mt-2 text-lg sm:text-xl font-bold">
                    {loanData?.max_loan_tenure || 30} Days
                  </h4>
                </div>

              </div>

              <div className="mt-8 space-y-4">

                <div className="flex items-center gap-3">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-green-500 text-white">
                    ✓
                  </span>
                  <span>Instant Approval</span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-green-500 text-white">
                    ✓
                  </span>
                  <span>No Hidden Charges</span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-green-500 text-white">
                    ✓
                  </span>
                  <span>Flexible Tenure</span>
                </div>

              </div>

            </div>
          </div>
          <div className="w-full">

            <div className="bg-white rounded-3xl shadow-xl p-5 sm:p-6 lg:p-8">

              <div className="mb-8">

                <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3557]">
                  Customize Your Loan
                </h2>

                <p className="mt-2 text-sm sm:text-base text-gray-500">
                  Adjust the sliders to see your loan details
                </p>

              </div>

              <div className="space-y-8">

                <div>

                  <label className="block mb-3 font-semibold text-[#1D3557]">
                    Purpose of Loan <span className="text-red-500">*</span>
                  </label>

                  <Select
                    className="w-full"
                    name="loanPurpose"
                    placeholder="Select purpose"
                    error={formDataError?.loanPurpose}
                    onChange={onChange}
                    value={formData.loanPurpose}
                    options={options}
                  />

                </div>

                {/* Principal */}

                <div>

                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">

                    <label className="font-semibold text-[#1D3557]">
                      Principal Amount
                      <span className="text-red-500">*</span>
                    </label>

                    <div className="bg-blue-50 rounded-full px-4 py-2 text-[#2D5F7A] font-semibold">
                      ₹ {principal.toLocaleString()}
                    </div>

                  </div>

                  <RangeSlider
                    min={loanData?.min_loan_amount || 5000}
                    step="500"
                    max={loanData?.max_loan_amount || 100000}
                    value={principal}
                    setValue={setPrincipal}
                  />

                  <div className="flex justify-between mt-3 text-xs text-gray-500">
                    <span>
                      ₹{(loanData?.min_loan_amount || 5000).toLocaleString()}
                    </span>

                    <span>
                      ₹{(loanData?.max_loan_amount || 100000).toLocaleString()}
                    </span>
                  </div>

                </div>

                {/* Tenure */}

                <div>

                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">

                    <label className="font-semibold text-[#1D3557]">
                      Loan Tenure
                      <span className="text-red-500">*</span>
                    </label>

                    <div className="bg-blue-50 rounded-full px-4 py-2 text-[#2D5F7A] font-semibold">
                      {tenure} Days
                    </div>

                  </div>

                  <RangeSlider
                    min={loanData?.min_loan_tenure || 1}
                    step="1"
                    max={loanData?.max_loan_tenure || 90}
                    value={tenure}
                    setValue={setTenure}
                  />

                  <div className="flex justify-between mt-3 text-xs text-gray-500">
                    <span>{loanData?.min_loan_tenure || 1} Days</span>
                    <span>{loanData?.max_loan_tenure || 90} Days</span>
                  </div>

                </div>

              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-8">

                <div className="flex items-center gap-4 rounded-2xl border border-gray-200 p-4">
                  <img src={principalIcon} alt="" className="w-10 h-10" />

                  <div>
                    <p className="text-sm text-gray-500">
                      Principal Amount
                    </p>

                    <h4 className="text-lg sm:text-xl font-bold text-[#1D3557]">
                      ₹{principal.toLocaleString()}
                    </h4>
                  </div>

                </div>

                <div className="flex items-center gap-4 rounded-2xl border border-gray-200 p-4">
                  <img src={paybleIcon} alt="" className="w-10 h-10" />

                  <div>
                    <p className="text-sm text-gray-500">
                      Total Payable
                    </p>

                    <h4 className="text-lg sm:text-xl font-bold text-[#1D3557]">
                      ₹{(Number(principal) + Number(emi)).toLocaleString()}
                    </h4>
                  </div>

                </div>

              </div>

              <div className="mt-6 rounded-2xl border border-green-200 bg-green-50 p-5 flex justify-between items-center">
                <span className="font-medium">
                  Interest Amount
                </span>

                <span className="text-lg font-bold text-green-700">
                  ₹{Math.round(emi).toLocaleString()}
                </span>
              </div>

              <div className="mt-8">
                <Button
                  title="Accept & Continue"
                  onClick={() => submit("1")}
                  loading={loadingAccept}
                  className="w-full bg-[#2D5F7A]"
                />
              </div>

              <p className="mt-5 text-center text-xs sm:text-sm text-gray-500">
                By accepting, you agree to our{" "}
                <a href="/terms" className="text-[#2D5F7A] font-semibold hover:underline">
                  Terms & Conditions
                </a>
              </p>

            </div>

          </div>

        </div>
      </div>
    </LoanCalculatorWrapper>
  );
}

export default LoanCalculator;